import "./header.scss";
import { AccountArea } from "@components/account";
import { FC, memo, useMemo } from "react";
import { useTitle } from "@contexts/title.context";
import { BrandIcon, MenuIcon } from "@components/icons";
import { AWSUser } from "@archetypes/auth";
import { Button } from "@components/button";
import { useFavicon } from "@hooks/use-favicon";
import { Link } from "react-router-dom";
import { AppData } from "@archetypes/app";
import { AppMenuSchemaType } from "@dialogs/app-add-edit-dialog/app-add-edit-form.schema";
// import { darkenColor } from "@utils/color.util";

interface HeaderProps {
  basePath: string;
  user?: AWSUser;
  appId?: string;
  onHeaderButtonClick?: () => void;
  isAppView?: boolean;
  appData?: AppData;
  menuData?: AppMenuSchemaType[];
  menuMap?: { [x: string]: AppMenuSchemaType };
  fontColor?: string;
  primaryColor?: string;
  isLeftMenuVisible?: boolean;
  toggleLeftMenu?: (value?: boolean) => void;
  isMobile?: boolean;
}

const HeaderComponent: FC<HeaderProps> = ({
  basePath,
  user,
  onHeaderButtonClick,
  isAppView,
  appData,
  fontColor = "#000",
  // primaryColor = "#fff",
  isLeftMenuVisible,
  toggleLeftMenu,
  isMobile,
}) => {
  const { title } = useTitle();

  const appMetaData = useMemo(() => {
    if (isAppView && appData) {
      return {
        titlePrefix: appData.appName,
        appLogo: appData.appLogo,
        faviconLogo: appData.favicon,
      };
    }
    return undefined;
  }, [appData, isAppView]);

  const header = useMemo(() => {
    if (!appMetaData?.titlePrefix) {
      return title;
    }
    if (title) {
      return appMetaData?.titlePrefix ?? "" + " > " + title;
    }
    return appMetaData?.titlePrefix ?? "";
  }, [title, appMetaData]);

  useFavicon(appMetaData?.faviconLogo);

  // const bgColor = darkenColor(primaryColor);

  return (
    <>
      <header>
        <div className="flex align-center w-100-104">
          {isAppView && isMobile && (
            <Button
              className={`toggle-menu ${isLeftMenuVisible ? "" : " open"}`}
              onClick={() => toggleLeftMenu?.()}
              variant="icon"
              style={{ background: fontColor }}
            >
              <MenuIcon />
            </Button>
          )}

          {isAppView ? (
            <Button className="logo only-desktop" onClick={onHeaderButtonClick}>
              {appMetaData?.appLogo ? (
                <img
                  src={appMetaData.appLogo}
                  alt="applogo"
                  className="logo"
                  decoding="async"
                  loading="eager"
                />
              ) : (
                <BrandIcon height="35" width="35" />
              )}
            </Button>
          ) : (
            <Link to={basePath === "/apps" ? "/apps" : "/builder/apps"} className="logo">
              <BrandIcon height="35" width="35" />
            </Link>
          )}

          <h1 className="page-title text-black">{header}</h1>
        </div>

        {user && (
          <div className="account-area">
            <AccountArea basePath={basePath} />
          </div>
        )}
      </header>
    </>
  );
};

export const Header = memo(HeaderComponent);
